import * as dateFns from 'date-fns'

import { PortfolioTransaction } from '../types'

export const PORTFOLIO_DATE_FORMAT_VIEW = 'MM-dd-yyyy'
export const PORTFOLIO_DATE_FORMAT_DATA = "yyyy-MM-dd'T00:00:00'"

export const PORTFOLIO_REFRESH_INTERVAL = (FinvizSettings.hasUserPremium ? 20 : 120) * 1000

export const TRANSACTION_LABEL: Record<PortfolioTransaction, string> = {
  [PortfolioTransaction.Watch]: 'Watch',
  [PortfolioTransaction.Buy]: 'Buy',
  [PortfolioTransaction.Short]: 'Short Sell',
}

export const EMPTY_FORM_ENTRY = {
  ticker: '',
  date: `${dateFns.format(new Date(), PORTFOLIO_DATE_FORMAT_DATA)}`,
  shares: undefined,
  price: undefined,
  transaction: PortfolioTransaction.Buy,
}

export const PORTFOLIO_INPUT_NAME = 'portfolio_name'
export const PORTFOLIO_INPUT_EMPTY_ERROR = 'Please enter portfolio name.'
export const PORTFOLIO_INPUT_EXISTS_ERROR = 'Portfolio with that name already exists.'
export const TICKERS_INPUT_NAME = 'tickers'
export const TICKERS_INPUT_FORMAT_TIP = 'Separate multiple tickers by a comma, e.g.: AAPL, MSFT, GOOG.'
